import * as React from 'react'


interface ParentProps {
    toggleFn: any;
    updatePushNotification: any;
    showPushNotification: boolean;
    locale: string;
    chatbotsettings: any;
}

interface RatingProps {
    showPopup: boolean,
    enablePushNotification: boolean,
    conversationId: string,
    pushLevelText?: string,
    yesButton?: string,
    noButton?: string
}


export class PushNotification extends React.Component<ParentProps, RatingProps> {
    state: RatingProps = {
        showPopup: this.props.showPushNotification,
        enablePushNotification: false,
        conversationId: ''
    };
       closePopupFn = () => {
        this.setState({
            showPopup: false,
            enablePushNotification: false,
            conversationId: ''
        })
           localStorage.setItem('enableOkButton', "true");
    }
    updateShowPopUp = (conversationid: any) => {
        localStorage.setItem('enableOkButton', "true");
        this.setState({ showPopup: true, enablePushNotification: true, conversationId: conversationid })
    }
    submitPopupFn = () => {
        let url = this.props.chatbotsettings.notificationurl + this.state.conversationId;
        localStorage.setItem('enableOkButton', "true");
        window.open(
            url, "_blank", 'location=yes,height=570,width=520,scrollbars=yes,status=yes');

        this.setState({
            showPopup: false,
            enablePushNotification: true,
        })
        
        this.props.updatePushNotification(this.state);
        
    }

    async componentDidMount() {
        // GET request using fetch with async/await
        const response = await fetch(this.props.chatbotsettings.configvaluesurl, {
            headers: {
                'ApiKey': this.props.chatbotsettings.configvaluesurlapikey,
                'Content-type': 'application/json'
            },
            method: 'GET'

        });
        if (this.state.showPopup == true) {
            localStorage.setItem('enableOkButton', "true");
        }
        const data = await response.json();

        if (this.props.locale === 'fr') {
            this.state.pushLevelText = data.filter((list: any) => list.referenceKey === 'Push Notification')[0].frenchMessage;
            this.state.yesButton = data.filter((list: any) => list.referenceKey === 'Yes Button')[0].frenchMessage;
            this.state.noButton = data.filter((list: any) => list.referenceKey === 'No Button')[0].frenchMessage;

        }
        else {

            this.state.pushLevelText = data.filter((list: any) => list.referenceKey === 'Push Notification')[0].message;
            this.state.yesButton = data.filter((list: any) => list.referenceKey === 'Yes Button')[0].message;
            this.state.noButton = data.filter((list: any) => list.referenceKey === 'No Button')[0].message;

        }
    }



    render() {
        
        return (
            <div>

                {this.state.showPopup ?
                    <div className="popup">
                        <div className="overlay popup-overlay"></div>
                        <div className="popup-container">
                            <div className="popup-content">
                                <div className="popup-top">
                                    <p> {this.state.pushLevelText}</p>
                                </div>
                                <div className="popupContent-container">
                                    <div className="btn-container">
                                        <button type="button"
                                            className="p-btn btn" onClick={this.submitPopupFn}>{this.state.yesButton} </button>
                                        <button type="button"
                                            className="s-btn btn" onClick={this.closePopupFn}>{this.state.noButton} </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    : ''}

            </div>
        );
    }
}
export default PushNotification;
